export default "__VITE_ASSET__B378PtZU__"